export default "__VITE_ASSET__BQ5E32m___"